/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "aslanwebsftpapi",
            "endpoint": "https://9yil3eh0u3.execute-api.eu-west-2.amazonaws.com/sit",
            "region": "eu-west-2"
        },
        {
            "name": "fileApi",
            "endpoint": "https://r4xlhhqxpj.execute-api.eu-west-2.amazonaws.com/sit",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:03effbb3-1271-4033-8a7b-01691b1b3bf4",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_3pwYaDW9m",
    "aws_user_pools_web_client_id": "2jd4loqm10t1mqv9vskvfrk129",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "userprofiles-sit",
            "region": "eu-west-2"
        },
        {
            "tableName": "companiesTable-sit",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
